var map = {
	"./layouts/card": 26,
	"./layouts/card/": 26,
	"./layouts/card/index": 26,
	"./layouts/card/index.tsx": 26,
	"./layouts/card/style.module": 154,
	"./layouts/card/style.module.scss": 154,
	"./layouts/components/breadcrumbs": 130,
	"./layouts/components/breadcrumbs/": 130,
	"./layouts/components/breadcrumbs/index": 130,
	"./layouts/components/breadcrumbs/index.tsx": 130,
	"./layouts/components/breadcrumbs/style.module": 191,
	"./layouts/components/breadcrumbs/style.module.scss": 191,
	"./layouts/components/container": 47,
	"./layouts/components/container/": 47,
	"./layouts/components/container/index": 47,
	"./layouts/components/container/index.tsx": 47,
	"./layouts/components/container/style.module": 132,
	"./layouts/components/container/style.module.scss": 132,
	"./layouts/components/footer": 131,
	"./layouts/components/footer/": 131,
	"./layouts/components/footer/index": 131,
	"./layouts/components/footer/index.tsx": 131,
	"./layouts/components/footer/style.module": 90,
	"./layouts/components/footer/style.module.scss": 90,
	"./layouts/components/loading_indicator": 62,
	"./layouts/components/loading_indicator/": 62,
	"./layouts/components/loading_indicator/index": 62,
	"./layouts/components/loading_indicator/index.tsx": 62,
	"./layouts/components/nav_bar": 100,
	"./layouts/components/nav_bar/": 100,
	"./layouts/components/nav_bar/index": 100,
	"./layouts/components/nav_bar/index.tsx": 100,
	"./layouts/components/nav_bar/standalone": 355,
	"./layouts/components/nav_bar/standalone.tsx": 355,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 87,
	"./layouts/components/notice_banner/": 87,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 192,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 192,
	"./layouts/components/notice_banner/index": 87,
	"./layouts/components/notice_banner/index.tsx": 87,
	"./layouts/components/notice_banner/standalone": 356,
	"./layouts/components/notice_banner/standalone.tsx": 356,
	"./layouts/components/notice_banner/style.module": 193,
	"./layouts/components/notice_banner/style.module.scss": 193,
	"./layouts/page": 103,
	"./layouts/page/": 103,
	"./layouts/page/index": 103,
	"./layouts/page/index.tsx": 103,
	"./layouts/page/style.module": 91,
	"./layouts/page/style.module.scss": 91,
	"./layouts/types": 357,
	"./layouts/types.ts": 357,
	"./marketing/pages/home/toefl": 1541,
	"./marketing/pages/home/toefl/": 1541,
	"./marketing/pages/home/toefl/index": 1541,
	"./marketing/pages/home/toefl/index.tsx": 1541,
	"./marketing/pages/home/toefl/sections/ai": 1142,
	"./marketing/pages/home/toefl/sections/ai/": 1142,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1774,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1774,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1775,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1775,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1776,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1776,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1777,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1777,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1778,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1778,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1779,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1779,
	"./marketing/pages/home/toefl/sections/ai/index": 1142,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1142,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1780,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1780,
	"./marketing/pages/home/toefl/sections/apps": 1143,
	"./marketing/pages/home/toefl/sections/apps/": 1143,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1781,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1781,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1782,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1782,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1783,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1783,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1784,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1784,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1785,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1785,
	"./marketing/pages/home/toefl/sections/apps/index": 1143,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1143,
	"./marketing/pages/home/toefl/sections/features": 1144,
	"./marketing/pages/home/toefl/sections/features/": 1144,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1786,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1786,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1787,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1787,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1788,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1788,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1789,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1789,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1790,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1790,
	"./marketing/pages/home/toefl/sections/features/index": 1144,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1144,
	"./marketing/pages/home/toefl/sections/official_questions": 1148,
	"./marketing/pages/home/toefl/sections/official_questions/": 1148,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1799,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1799,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1148,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1148,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 673,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 673,
	"./marketing/pages/home/toefl/sections/value_props": 1145,
	"./marketing/pages/home/toefl/sections/value_props/": 1145,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1791,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1791,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1792,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1792,
	"./marketing/pages/home/toefl/sections/value_props/index": 1145,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1145,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2191,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2191,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1146,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1146,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1793,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1793,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1794,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1794,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1795,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1795,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1796,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1796,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1797,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1797,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1146,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1146,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 672,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 672,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1147,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1147,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1798,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1798,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1147,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1147,
	"./marketing/pages/home/toefl/style.module": 1800,
	"./marketing/pages/home/toefl/style.module.scss": 1800,
	"./marketing/pages/plans/toefl": 1542,
	"./marketing/pages/plans/toefl/": 1542,
	"./marketing/pages/plans/toefl/index": 1542,
	"./marketing/pages/plans/toefl/index.tsx": 1542,
	"./marketing/pages/plans/toefl/sections/testimonials": 1149,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1149,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1801,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1801,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1802,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1802,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1149,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2529;